<template>
  <div class="distribution-promotion">
    <ContentBlock style="padding: 10px 10px 0;margin-top: 5px;">
      <el-descriptions :column="3" size="normal" style="padding: 0 10px;">
        <el-descriptions-item label="推广员ID">{{ info.code || '--' }}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{ info.name || '--' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ info.phoneNumber || '--' }}</el-descriptions-item>
        <el-descriptions-item label="佣金账户信息">{{ info.bankAccount ? `${info.bankName}_${info.bankAccount}` : '--' }}</el-descriptions-item>
      </el-descriptions>
    </ContentBlock>
    <ContentBlock>
      <el-tabs v-model="activeName">
        <el-tab-pane label="邀请用户" name="invite"></el-tab-pane>
        <el-tab-pane label="佣金明细" name="commission"></el-tab-pane>
      </el-tabs>
      <TableWithPagination v-if="activeName === 'invite'" class="special" :columnList="columnList" :tableData="targetLists"
        :sortInfo.sync="updateSortInfo" tableBorder="default" :pagination.sync="pagination"
        @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="handleSortChange"
        :highHoverRow="false" :highlightRow="false" />
      <el-empty v-if="activeName === 'commission'" description="暂无数据"></el-empty>
    </ContentBlock>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import * as dayjs from 'dayjs';
import { promoterInviteUserPageList } from '@/api/distribution';

export default {
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  computed: {
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '姓名',
          minWidth: '150px',
          width: '',
          prop: 'inviteUserName',
        },
        {
          tooltip: true,
          label: '手机号',
          minWidth: '150px',
          width: '',
          prop: 'inviteUserPhoneNumber',
        },
        {
          tooltip: true,
          label: '行为类型',
          minWidth: '150px',
          width: '',
          prop: 'behaviorTypeDesc',
        },
        {
          tooltip: true,
          label: '关联企业',
          minWidth: '150px',
          width: '',
          prop: 'inviteUserTenantName',
          render: (h, {row}) => {
            // behaviorType行为类型【1：登录注册；2：企业入驻；3：企业认证；4：个人认证】
            return <span>{[2, 3].includes(row.behaviorType) ? row.inviteUserTenantName : '--'}</span>;
          },
        },
        {
          tooltip: true,
          label: '发生时间',
          minWidth: '150px',
          width: '',
          prop: 'occurrenceTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
      ];
      return cols;
    },

  },
  data () {
    return {
      id: this.$route.query.promoterId,
      info: this.$route.query.info || {},
      activeName: 'invite',
      targetLists: [],
    };
  },
  mounted () {
    this.getTargetLists();
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    handleSortChange () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    getTargetLists () {
      if (!this.id) return;
      const params = {
        promoterId: this.id,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orderBy: [this.updateSortInfo],
      };

      promoterInviteUserPageList(params).then(({ body }) => {
        this.targetLists = body?.list || [];

        this.pagination.total = body?.total || 0;
      });
    },
  },
};
</script>
